var s = Object.defineProperty;
var l = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable;
var i = (e, C, t) => C in e ? s(e, C, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[C] = t, c = (e, C) => {
  for (var t in C || (C = {}))
    n.call(C, t) && i(e, t, C[t]);
  if (l)
    for (var t of l(C))
      w.call(C, t) && i(e, t, C[t]);
  return e;
};
var m = (e, C) => {
  var t = {};
  for (var a in e)
    n.call(e, a) && C.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && l)
    for (var a of l(e))
      C.indexOf(a) < 0 && w.call(e, a) && (t[a] = e[a]);
  return t;
};
import * as r from "react";
const h = (a) => {
  var o = a, {
    title: e,
    titleId: C
  } = o, t = m(o, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ r.createElement("svg", c({ width: 32, height: 32, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": C }, t), e ? /* @__PURE__ */ r.createElement("title", { id: C }, e) : null, /* @__PURE__ */ r.createElement("path", { d: "M5.33392 21.9975C4.60815 22.029 3.89951 21.7572 3.36405 21.242C2.82859 20.7268 2.50991 20.0103 2.47678 19.2487C2.47591 19.2226 2.47769 19.1963 2.48236 19.1706L3.43474 7.87807C3.4534 7.62773 3.56067 7.3948 3.73608 7.22404C3.91148 7.05328 4.1423 6.95732 4.38154 6.95658H7.33355C7.55213 5.82676 8.1367 3.85804 8.98719 3.12844C9.83768 2.39884 10.9022 2 12.0006 2C13.099 2 14.1635 2.39884 15.014 3.12844C15.8645 3.85804 16.449 5.82676 16.6676 6.95658H19.6196C19.8599 6.95581 20.0922 7.05118 20.2688 7.22209C20.4454 7.393 20.5533 7.6267 20.572 7.87807L21.5244 19.1706C21.5244 19.1956 21.5244 19.2237 21.5244 19.2487C21.4905 20.01 21.1706 20.727 20.6353 21.242C20.1 21.757 19.3928 22.0282 18.6673 21.9975H5.33392ZM14.694 6.95658C14.4965 6.3729 14.1307 4.91478 13.6487 4.55753C13.1666 4.20028 12.5926 4.00893 12.0024 4.00893C11.4123 4.00893 10.8365 4.20028 10.3544 4.55753C9.87228 4.91478 9.5065 6.3729 9.30899 6.95658H14.694Z" }));
};
export {
  h as default
};
